import type { ProductGenderId } from 'product/types/Product'

enum Gender {
	Male = 'male',
	Female = 'female',
}

const genderMap: Partial<Record<ProductGenderId, Gender>> = {
	M: Gender.Female, // Mango Woman
	H: Gender.Male, // Mango Man
	Q: Gender.Female, // Teen niña
	P: Gender.Male, // Teen niño
}

const genderKey: Record<Gender, string> = {
	[Gender.Female]: 'pdp.sizeSelector.modelMeasurements.text',
	[Gender.Male]: 'pdp.sizeSelector.modelMeasurements.man.text',
}

export const getGenderKey = (genderId: ProductGenderId): string | null => {
	const gender: Gender | undefined = genderMap[genderId]
	if (!gender) {
		return null
	}
	return genderKey[gender]
}
